import { render } from "./UpdateLTLInvoice.vue?vue&type=template&id=6727cc6c&scoped=true&ts=true"
import script from "./UpdateLTLInvoice.vue?vue&type=script&lang=ts"
export * from "./UpdateLTLInvoice.vue?vue&type=script&lang=ts"

import "./UpdateLTLInvoice.vue?vue&type=style&index=0&id=6727cc6c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6727cc6c"]])

export default __exports__